import { supabase } from './supabase';

export type Provider = 'openai' | 'spotify' | 'meta';

export type IntegrationData = {
  openai_api_key?: string;
  openai_model?: string;
  spotify_client_id?: string;
  spotify_client_secret?: string;
  meta_app_id?: string;
  meta_app_secret?: string;
  [k: string]: any;
};

export const integrationSettings = {
  async get(provider: Provider): Promise<IntegrationData | null> {
    const { data: user } = await supabase.auth.getUser();
    const userId = (user as any)?.user?.id;
    if (!userId) {
      // Fallback to localStorage in unauthenticated dev
      try {
        const local = localStorage.getItem(`int_${provider}`);
        return local ? JSON.parse(local) : null;
      } catch { return null; }
    }
    const { data, error } = await supabase
      .from('integration_settings')
      .select('data')
      .eq('user_id', userId)
      .eq('provider', provider)
      .single();
    if (error) return null;
    return (data as any)?.data || null;
  },

  async set(provider: Provider, dataIn: IntegrationData): Promise<boolean> {
    const { data: user } = await supabase.auth.getUser();
    const userId = (user as any)?.user?.id;
    if (!userId) {
      try {
        localStorage.setItem(`int_${provider}`, JSON.stringify(dataIn));
        return true;
      } catch { return false; }
    }
    const payload = { user_id: userId, provider, data: dataIn } as any;
    const { error } = await supabase
      .from('integration_settings')
      .upsert(payload, { onConflict: 'user_id,provider' });
    return !error;
  }
};
